import { useMutation, useQueryClient } from '@tanstack/react-query';
import { makeRequest } from '../../data/makeRequest';

type CreateSurveyInvitationRequest = {
	projectId: number;
	entryId: string;
	seriesName: string;
	formId: number;
	surveyName: string;
};

export const useCreateSurveyInvitationMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (data: CreateSurveyInvitationRequest) =>
			makeRequest<{
				surveyId: string;
				pinCode: string;
			}>({
				method: 'createSurveyInvitation',
				service: 'cde',
				data
			}),
		onSuccess: (_, args) => {
			queryClient.invalidateQueries({
				queryKey: ['surveyInvitations', args.projectId, args.entryId, args.seriesName]
			});
		}
	});
};
